import {
  IonAvatar,
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonHeader,
  IonIcon,
  IonImg,
  IonPage,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import { close } from "ionicons/icons";
import UserName from "../components/UserName";
import LobbyInfo from "../components/LobbyInfo";
import { useAuthStore } from "../stores/auth.store";
import LobbyPlacings from "../components/LobbyPlacings";
import { ReactComponent as BotIcon } from "../assets/graphics/smart_toy.svg";
import { ReactComponent as TradesIcon } from "../assets/graphics/mode_heat.svg";
import { ReactComponent as StreaksIcon } from "../assets/graphics/mode_streaks.svg";
import PrizeSummary from "../components/PrizeSummary";
import SaveStrategyButton from "../components/SaveStrategyButton";

interface Props {
  onDismiss: () => () => void;
  lobby: any;
}

const LobbySummary: React.FC<Props> = ({ onDismiss, lobby }) => {
  const userId = useAuthStore(state => state.user?.uid);
  const userBots: any[] = lobby?.standings?.filter(
    (s: any) => s.user === userId
  );
  const botPayouts = userBots?.map((b: any) => b.earnings);
  const totalEarnings =
    botPayouts?.reduce((acc: any, payout: number) => acc + payout, 0) || 0;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton onClick={onDismiss}>
              <IonIcon icon={close} />
            </IonButton>
          </IonButtons>
          <IonTitle>Summary</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="bg-primary-90">
          <IonCard>
            <div className="bg-primary-50 p-4 text-white w-full">
              <div>Lobby</div>
              <div className="font-semibold text-lg">{lobby?.name}</div>
              <UserName userId={lobby?.administrators[0]} />
            </div>
            <LobbyInfo lobby={lobby} />
            <div className="flex text-center">
              <div className="bg-primary-50 w-full font-bold text-white py-4 text-lg">
                Total Earnings
              </div>
              <div className="bg-primary-80 w-full text-green-400 font-bold text-xl py-4">
                {totalEarnings.toFixed(2)} QUO
              </div>
            </div>
          </IonCard>
          <div className="h-[1px] bg-primary-80 w-full px-4"></div>
          <IonCard>
            <div className="flex flex-col grow rounded-t-lg bg-primary-90">
              <div className="flex items-center bg-primary-70 p-2">
                <div className="bg-primary-80 text-primary-50 p-1 h-6 w-6 rounded-md text-sm">
                  <BotIcon style={{ width: "16px", height: "16px" }} />
                </div>
                <div className="text-lg text-white font-semibold ml-2">
                  My Bots ({userBots?.length || 0})
                </div>
              </div>
              <div className="h-1 bg-primary-90"></div>
              {userBots?.map((bot: any) => (
                <div key={`my-bots-${bot.botId}`}>
                  <div className="flex bg-primary-80 p-2 border-b border-primary-80 rounded">
                    <IonAvatar className="h-9 w-9">
                      <IonImg src={bot?.img} />
                      <span className="absolute -mt-3 px-1 rounded-full bg-primary-90 text-yellow-400 text-sm">
                        {lobby?.standings?.findIndex(
                          (s: any) => s.botId === bot.botId
                        ) + 1}
                      </span>
                    </IonAvatar>
                    <div className="flex flex-col justify-center px-2 text-sm text-white capatilize">
                      {bot.name}
                    </div>
                    <div className="flex items-center ml-auto w-min gap-x-4">
                      <div className="flex text-xs text-white">
                        <div className="bg-[#ff7f0a] opacity-70 p-[2px] rounded h-4 mr-1">
                          <TradesIcon />
                        </div>
                        {bot?.tradeCount}
                      </div>
                      <div className="text-xs text-white flex">
                        <StreaksIcon /> {bot?.profitStreak}/
                        {bot?.maxProfitStreak}
                      </div>
                      <SaveStrategyButton bot={bot} />
                    </div>
                  </div>
                  <div className="flex justify-between gap-x-1 pt-1">
                    <div className="flex flex-col bg-primary-80 items-center text-primary-50 p-4 gap-2 rounded w-1/3">
                      <div className="text-white text-xs">RANK</div>
                      <div className="text-xl font-semibold">
                        {lobby?.standings?.findIndex(
                          (s: any) => s.botId === bot.botId
                        ) + 1}
                      </div>
                      <div className="text-sm">
                        [ {lobby?.bots?.length} BOTS ]
                      </div>
                    </div>
                    <div className="flex flex-col bg-primary-80 items-center text-primary-50 py-4 px-2 gap-2 rounded w-1/3">
                      <div className="text-white text-xs">TOTAL PROFIT</div>
                      <div
                        className={`text-xl font-semibold ${
                          bot?.profit &&
                          (bot.profit < 0 ? "text-red-400" : "text-green-400")
                        }`}
                      >
                        {bot?.profit?.toFixed(2)}%
                      </div>
                      <div className="text-sm">
                        [ {lobby?.bots?.length} BOTS ]
                      </div>
                    </div>
                    <div className="flex flex-col bg-primary-80 items-center text-primary-50 p-4 gap-2 rounded w-1/3">
                      <div className="text-white text-xs">EARNINGS</div>
                      <div className="text-xl font-semibold">
                        {bot?.earnings?.toFixed(2)}
                      </div>
                      <div className="text-sm">QUOCOIN</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </IonCard>
          <div className="h-[1px] bg-primary-80 w-9/10 mx-4"></div>
          <LobbyPlacings lobby={lobby} instanceId={2} />
          <div className="h-[1px] bg-primary-80 w-9/10 mx-4"></div>
          <PrizeSummary lobby={lobby} />
        </div>
      </IonContent>
    </IonPage>
  );
};

export default LobbySummary;
